document.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('[href^="#trigger-popup"]')
	const popups = document.querySelectorAll('.popup')

	// Specific function(s) for plan popup(s)
	const setPlan = (popup, plan) => {
		let planSelect = popup.querySelector('select[name="plan"]')
		if (planSelect) {
			planSelect.value = plan
		}
	}

	triggers?.forEach(trigger => {
		trigger.addEventListener('click', e => {
			e.preventDefault()
			let popup = document.getElementById(
				e.target.getAttribute('href').split('#trigger-popup-')[1]
			)

			if (trigger.dataset.plan) {
				setPlan(popup, trigger.dataset.plan)
			}

			popup.classList.add('show')
		})
	})

	popups?.forEach(popup => {
		let closeBtn = popup.querySelector('button.close')

		// Remove inline style on load (used to prevent popups from fading out on page load)
		popup.setAttribute('style', '')

		closeBtn?.addEventListener('click', () => {
			popup.classList.remove('show')
		})

		window.addEventListener('click', e => {
			let href = e.target.getAttribute('href')
			if (href) {
				href = href.includes('#trigger-popup')
			}

			if (!e.target.closest('.card') && !href) {
				popup.classList.remove('show')
			}
		})
	})
})
